import { useTranslation } from "react-i18next";
import "./AddCategory.css";

function AddCategory({ onClick }) {
  const { t: tCommon } = useTranslation("common");
  return (
    <button
      className="add-category"
      onClick={onClick} // Adicionando evento para criar nova categoria
    >
      <p className="add-category__text">{tCommon("add")}</p>
    </button>
  );
}

export default AddCategory;
